import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

const ScheduleInternalMultiApprovalSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [successPageData, setSuccessPageData] = useState([]);
  const [successPageID, setSuccessPageID] = useState([]);

  useEffect(() => {
    try {
      const storedData = sessionStorage.getItem("intSelectedScheduleCard");
      const storedSelectedApproval = storedData ? JSON.parse(storedData) : [];

      const selectedApproval = Array.isArray(storedSelectedApproval)
        ? storedSelectedApproval[0]
        : null;

      const selectedDetails = Array.isArray(selectedApproval?.selectedDetails)
        ? selectedApproval.selectedDetails
        : [];

      const selectedIds = Array.isArray(selectedApproval?.selectedIds)
        ? selectedApproval.selectedIds
        : [];

      setSuccessPageData(selectedDetails);
      setSuccessPageID(selectedIds);
    } catch (error) {
      console.error("Failed to load selected schedule details:", error);
      setSuccessPageData([]);
      setSuccessPageID([]);
    }
  }, []);

  useEffect(() => {
    dispatch(disableSwitcher());
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const goToDashboard = () => {
    navigate("/internal_transaction_dashboard");
  };

  const approveMoreSchedules = () => {
    navigate("/internal_transaction_dashboard/schedule_multi_approval");
  };

  const buttonRows = [
    [
      {
        btnText: "Approve more schedules",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: approveMoreSchedules,
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const ScheduleList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions.map((transaction, index) => {
        const scheduleDetailPath = `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${transaction?.txn_id}`;

        return (
          <InfoCard
            key={transaction?.txn_id ?? index}
            bgColor="var(--positive-card)"
            hoverable="white"
            onClick={() => navigate(scheduleDetailPath)}
            rows={[
              {
                leftTitle: transaction?.scheduled_name,
                leftSubTitle: "Schedule name",
                hasRight: true,
                rightText: true,
                rightTitleTextColor: "var(--text-primary)",
                rightTitle: (
                  <>
                    INR <FormatAmount price={transaction?.amount} />
                  </>
                ),
                rightTextFontWeight: "semibold",
                rightSubTitle: "Amount",
                rightIcon: true,
                onClick: () => navigate(scheduleDetailPath),
              },
            ]}
          />
        );
      })}
    </div>
  );

  return (
    <StatusContainer
      status="success"
      title={successPageData.length && "Schedules approved successfully."}
      buttonRows={buttonRows}
    >
      {successPageData.length > 0 && (
        <TabsWeapperSection
          title={`Approved Schedules - ${successPageID.length}`}
        >
          <ScheduleList transactions={successPageData} />
        </TabsWeapperSection>
      )}
    </StatusContainer>
  );
};

export default ScheduleInternalMultiApprovalSuccess;
